import {Component,Inject,OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ApiClefsService} from '@services/admin/parametre/api/api-clefs.service';
import {ExportClef} from '@domain/admin/parametre/api/clefs/ExportClef';
import {handleResult} from '@share/utils/handle-result';
import * as _ from "lodash";
import {finalize} from "rxjs/operators";

/**
 * Popin de création d'une clef API
 *
 * @author Lionel Gimenez
 */
@Component({
    host: {'data-test-id': 'api-clef-add'},
    templateUrl: './api-clef-add.component.html'
})
export class ApiClefAddComponent implements OnInit {
    /** Modèle de la clef à créer */
    exportClef: ExportClef;

    /** Indicateur en cours de maj */
    isUpdate: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        private apiClefsService: ApiClefsService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private dialogRef: MatDialogRef<ApiClefAddComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { ancienneClef: ExportClef },
    ) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Si ancienneClef est non null
        if (this.data?.ancienneClef != null) {
            //Duplication de l'ancienne clef
            this.exportClef = _.cloneDeep(this.data.ancienneClef);
        } else {
            //Sinon, instanciation d'une nouvelle clef
            this.exportClef = new ExportClef();
        }
    }

    /**
     * Validation et sauvegarde de la clef
     */
    onSubmit(): void {
        //Validation minimale
        if (!this.exportClef?.clef || !this.exportClef?.valeur) {
            //Affichage d'une erreur générique
            this.toastrService.error(this.translateService.instant('global.errors.formInvalid'));
            return;
        }

        //Maj de l'indicateur
        this.isUpdate = true;

        //Appel service de sauvegarde
        this.apiClefsService.saveClef([this.data?.ancienneClef,this.exportClef])
            .pipe(
                finalize(() => this.isUpdate = false),
                handleResult(this.translateService,this.toastrService,'global.success.enregistrement','global.errors.enregistrement'))
            .subscribe(result => {
                if (result) {
                    //Fermeture de la popin et demande de rafraichissement
                    this.dialogRef.close(true);
                }
            });
    }
}
